<template>
  <div class="common-box">
    <el-form
      inline
      ref="form"
      class="search-form common-box-search-form"
      label-position="right"
      :model="form"
      label-width="70px"
    >
      <search-form
        @search="handleSearch"
        @refresh="handleRefresh"
      >
        <div slot="content">
          <el-form-item label="客户名称：">
            <el-input
              @change="handleSearchListData"
              size="mini"
              v-model.trim="form.contactsName"
              placeholder="请输入客户名称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="客户电话：">
            <el-input
              @change="handleSearchListData"
              size="mini"
              v-model.trim="form.contactsPhone"
              placeholder="请输入客户电话"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="信用代码：">
            <el-input
              @change="handleSearchListData"
              size="mini"
              v-model.trim="form.creditCode"
              placeholder="请输入信用代码"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="单位名称：">
            <el-input
              @change="handleSearchListData"
              size="mini"
              v-model.trim="form.unitName"
              placeholder="请输入单位名称"
              clearable
            ></el-input>
          </el-form-item>
        </div>
      </search-form>
    </el-form>
    <div class="common-cover-div"></div>
    <div class="operation-and-table__container">
      <div class="btns__container">
        <el-button v-if="hasRole['DWGLTJ']" size="mini" type="primary" class="plr28" @click="handleAdd">添加</el-button>
        <el-button
          size="mini"
          type="primary"
          class="plr28"
          @click="handleDelete"
          plain
          v-if="hasRole['DWGLSC']"
        >删除</el-button>
        <el-button
          size="mini"
          type="primary"
          @click="exportUnit"
          plain
          class="plr28"
          v-if="hasRole['DWGLDC']"
        >导出</el-button>
      </div>
      <div class="table__container">
        <el-table
          v-loading="tableLoading"
          :data="list"
          height="100%"
          border
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column show-overflow-tooltip prop="unitName" label="单位名称" width="260"></el-table-column>
          <el-table-column show-overflow-tooltip prop="creditCode" label="信用代码" width="200"></el-table-column>
          <el-table-column show-overflow-tooltip prop="contactsName" label="联系人" width="200"></el-table-column>
      		<el-table-column show-overflow-tooltip prop="contactsPhone" label="联系电话" width="200"></el-table-column>
      		<el-table-column label=" " prop=" "></el-table-column>
          <el-table-column label="操作" width="176px" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" type="text" v-if="hasRole['DWGLCK']" @click="handleCheck(scope.row)">查看部门</el-button>
              <div class="btn-divide" v-if="hasRole['DWGLCK']"></div>
              <el-button size="mini" v-if="hasRole['DWGLBJ']" type="text" @click="handleEdit(scope.row)">编辑</el-button>
              <div class="btn-divide" v-if="hasRole['DWGLBJ']"></div>
              <el-button size="mini" v-if="hasRole['DWGLSC']" type="text" @click="handleDeleteUnit(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagenation__container">
        <div class="for-fff-bg">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-sizes="[25, 50, 100, 150, 200]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
    <add-unit
      v-if="addUnitVisible"
      @cancel="addUnitVisible = false"
      @confirm="handleAddUnitConfirm"
    ></add-unit>
    <edit-unit
      v-if="editUnitVisible"
      :editData="unitDetail"
      @cancel="editUnitVisible = false"
      @confirm="handleEditUnitConfirm"
    ></edit-unit>
    <check-unit
      v-if="checkUnitVisible"
      :editData="unitDetail"
      @cancel="checkUnitVisible = false"
    ></check-unit>
    <check-department
      v-if="checkDepartment"
      :editData="unitDetail"
      @cancel="checkDepartment = false"
    ></check-department>
  </div>
</template>

<script>

  import { getUnitList, deleteUnit, exportUnit } from '@/api/MaintenanceDetail'

  import AddUnit from './components/AddUnit'
  import EditUnit from './components/EditUnit'
  import CheckUnit from './components/CheckUnit'
  import CheckDepartment from './components/CheckDepartment'
  export default {
    name: 'MaintenanceDetail',
    components: {
      AddUnit,
      EditUnit,
      CheckUnit,
      CheckDepartment
    },
    data() {
      return {
        form: {
          contactsName: '',
          contactsPhone: '',
          creditCode: '',
          unitName: ''
        },
        tableLoading: false,
        list: [],
        multipleSelection: [],
        pageIndex: 1,
        pageSize: 50,
        total: 0,
        addUnitVisible: false,
        editUnitVisible: false,
        checkUnitVisible: false,
        checkDepartment: false,
        unitDetail: {}
      }
    },
    computed: {
      hasRole: function() {
        return this.$store.getters['common/promise/getRole'](this.$route.path);
      }
    },
    created() {
      this.getListData()
    },
    methods: {
      async getListData() {
       this.tableLoading = true
       const params = {
         pageIndex: this.pageIndex,
         pageSize: this.pageSize
       }
       for(let key in this.form) {
         if (this.form[key])
          params[key] = this.form[key]
       }
        const res = await getUnitList(params)
        if (res.code === 200) {
          this.total = res.data.total
          this.list = res.data.list
        }
        this.tableLoading = false
      },
      handleSearch() {
        this.pageIndex = 1
        this.getListData()
      },
      handleRefresh() {
        for(let key in this.form) {
          if (Array.isArray(this.form[key])) {
            this.form[key] = []
          } else {
            this.form[key] = ''
          }
        }
        this.pageIndex = 1
        this.getListData()
      },
      handleSearchListData() {
        this.pageIndex = 1
        this.getListData()
      },
      handleSelectionChange(val) {
        this.multipleSelection = val
      },
      handleDeleteUnit(row) {
        const idList = [row.id]
        this.deleteUnit(idList)
      },
      handleCheck(row) {
        this.unitDetail = row
        this.checkDepartment = true
      },
      handleEdit(row) {
        this.unitDetail = row
        this.editUnitVisible = true
      },
      handleDelete() {
        if (!this.multipleSelection.length) {
          this.$message.warning('请选择要删除的行')
          return
        }
        const idList = this.multipleSelection.map(item => item.id)
        this.deleteUnit(idList)
      },
      deleteUnit(idList) {
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          const res = await deleteUnit({idList})
          if (res.code === 200) {
            this.$message.success('删除成功')
            this.getListData()
          }
        }).catch((err) => {
          console.log(err)
        })

      },
      handleAdd() {
        this.addUnitVisible = true
      },
      exportUnit() {
        const params = {
          pageIndex: this.pageIndex,
          pageSize: this.pageSize
        }
        for(let key in this.form) {
          if (this.form[key])
            params[key] = this.form[key]
        }
        exportUnit(params)
      },
      handleSizeChange(val) {
        this.pageSize = val
        this.getListData()
      },
      handleCurrentChange(val) {
        this.pageIndex = val
        this.getListData()
      },
      handleAddUnitConfirm () {
        this.addUnitVisible = false
        this.pageIndex = 1
        this.getListData()
      },
      handleEditUnitConfirm () {
        this.editUnitVisible = false
        this.getListData()
      },

    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/MaintenanceDetail/MaintenanceDetail.vue